import { createFileRoute } from "@tanstack/react-router";

// Thẻ nằm trên URL để gửi được đường dẫn thẳng tới đúng thẻ (khuôn
// /branch-kpi, /retouch): của tôi · đội · chấm điểm.
//
// `incident` là mã phiếu lỗi: nút trong thư HRM mở /performance?incident=<mã>
// (backend hrmIncidentURL), nên route phải giữ tham số này để màn tìm đúng phiếu.
type PerformanceSearch = { tab?: string | undefined; incident?: string | undefined };

export const Route = createFileRoute("/_app/performance/")({
  validateSearch: (search: Record<string, unknown>): PerformanceSearch => ({
    tab: typeof search.tab === "string" ? search.tab : undefined,
    incident: typeof search.incident === "string" && search.incident ? search.incident : undefined,
  }),
});
